import type { CSSProperties } from "react";
import { cx } from "../cx";
import styles from "./Spinner.module.css";

export interface SpinnerProps {
  size?: number;
  className?: string;
  label?: string;
}

export function Spinner({ size = 24, className, label = "Loading" }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cx(styles.spinner, className)}
      style={{ "--spinner-size": `${size}px` } as CSSProperties}
    />
  );
}

export function FullPageSpinner() {
  return (
    <div className={styles.fullPage}>
      <Spinner size={40} />
    </div>
  );
}

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  /** Round for avatars. */
  circle?: boolean;
  className?: string;
}

export function Skeleton({ width = "100%", height = 14, circle, className }: SkeletonProps) {
  return (
    <span
      aria-hidden="true"
      className={cx(styles.skeleton, circle && styles.circle, className)}
      style={{ width, height }}
    />
  );
}
